<div class="kanbanboardview">
  <app-branding-header-bar></app-branding-header-bar>
  <app-informationview [viewName]="'taskboardview'"></app-informationview>

  <div class="actionview" cdkDropListGroup>
    <mat-form-field class="choose-swimlane">
      <mat-select placeholder="Choose Swimlane" [(value)]="selectedSwimlane" (selectionChange)="loadComponent()">
        <mat-option value="default" [translate]="'actionview.kanban.noswimlane'">Default</mat-option>
        <mat-option value="noswimlane" [translate]="'actionview.kanban.noswimlane'">No Swimlanes</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-slide-toggle style="margin-left: 50px;"
      [ngModel]="expediteLane"
      (ngModelChange)="expediteLaneChange($event)"
      [translate]="'actionview.kanban.expediteLane'">
      Expedite Lane
    </mat-slide-toggle>

    <div id="kanban-main-container">
      <app-kanban-backlog [parent]="this"></app-kanban-backlog>
      <ng-template appKanbanGrid></ng-template>
    </div>
  </div>


  <app-footerbar></app-footerbar>
</div>
